import * as React from 'react';

import errorLogger from 'utils/errorLogger';
// @ts-ignore
import LanguageHoverCard from 'chat/components/LanguageHoverCard';
import LayerTrigger from 'components/LayerTrigger';
import Link from 'components/Link';
import TranslationActions from 'actions/TranslationActions';

function handleTranslateTo(
  lang: string,
  text: string,
  onTextChange?: (text: string) => void,
  onLangChange?: (lang: string) => void
) {
  TranslationActions.translate(text, lang)
    .then(response => {
      if (onLangChange) {
        onLangChange(lang);
      }
      if (onTextChange) {
        onTextChange(response.translation);
      }
    })
    .catch(errorLogger('TranslateButton translate failed'));
}

export default function TranslateButton(props: {
  onTextChange?: (text: string) => void;
  onLangChange?: (lang: string) => void;
  textToTranslate: string;
  label?: React.ReactNode;
  className?: string;
  eventKey?: string;
  dataTestSelector?: string;
}) {
  const {
    textToTranslate,
    className,
    eventKey,
    dataTestSelector,
    onTextChange,
    label,
    onLangChange,
  } = props;

  const buttonLabel = label || 'Translate';
  return textToTranslate ? (
    <LayerTrigger
      trigger="click"
      placement="bottom"
      layer={
        <LanguageHoverCard
          onLanguagePicked={(lang: string) =>
            handleTranslateTo(lang, textToTranslate, onTextChange, onLangChange)
          }
        />
      }>
      <Link className={className} eventKey={eventKey} data-test-selector={dataTestSelector}>
        {buttonLabel}
      </Link>
    </LayerTrigger>
  ) : (
    <Link className={className} disabled>
      {buttonLabel}
    </Link>
  );
}
